import Axios from './config';

export const baseURL = 'https://api.sqgj.gov.cn';

export const getTagInfoRequest = () => {
  return Axios.post('/v1/sims/staff_tag/back_list',{})
}

// 统一登录
export const getUnifyLogin = (payload) => {
  return Axios.get(`/v1/sqgj/uc/app/${payload}`)
}

// 账号登录
export const getLoginRequest = (payload) => {
  window.localStorage.removeItem('token')
  return Axios.post('/v1/sqgj/uc/username_session/login', payload)
}

// 账号登录（需手机验证）- 账号登录
export const getUserLoginRequest = (payload) => {
  window.localStorage.removeItem('token')
  return Axios.post('/v1/sqgj/uc/username_mobile_session/username_login', payload)
}

// 账号登录（需手机验证） - 手机验证
export const getUserMobileLoginRequest = (payload) => {
  window.localStorage.removeItem('token')
  return Axios.post('/v1/sqgj/uc/username_mobile_session/mobile_login', payload)
}

// 获取验证码
export const getSafeCodeRequest = (payload) => {
  return Axios.post('/v1/sqgj/uc/session/captcha/request_image_code', payload)
}


// 获取短信验证码
export const getMsgCodeRequest = (payload) => {
  return Axios.post('/v1/sqgj/uc/session/captcha/request_sms_code', payload)
}

// 手机登录
export const getMsgLoginRequest = (payload) => {
  window.localStorage.removeItem('token')
  return Axios.post('/v1/sqgj/uc/mobile_session/login', payload)
}

// 绑定手机
export const getBindMobileRequest = (payload) => {
  return Axios.put('/v1/sqgj/uc/user/bind_mobile', payload)
}

